import { useTranslation } from "react-i18next";
import "./AboutUsDetails.scss";
import { Col, Row } from "antd";
import bglogo from "../../assets/images/bg-logo.svg";
import bglogo_ar from "../../assets/images/bg-logo 1.svg";
import aboutUsPage from "../../assets/images/about-us-2.svg";
import { useEffect } from "react";

const AboutUsDetails = () => {
  const { t, i18n } = useTranslation("common");

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <section className="about-us-detail-section">
      <div className="container">
        <div>
          <h1 className="detail-heading">
            {t("about-us-details-page.heading")}
          </h1>
          <p
            className="detail-para"
            dangerouslySetInnerHTML={{
              __html: t("about-us-details-page.description"),
            }}
          ></p>
        </div>

        {/* SECTION 1: On mobile - Text first, Image second */}
        <div className="content-section">
          <Row className="mobile-direction-chng" gutter={[16, 16]}>
            {/* IMAGE COLUMN - Should come second on mobile */}
            <Col xs={24} lg={12} className="mobile-order-2">
              <div className="about-us-details-bg">
                <img
                  src={i18n.language == "en" ? bglogo : bglogo_ar}
                  alt="loading-tournament"
                  loading="lazy"
                />
              </div>
            </Col>

            {/* TEXT COLUMN - Should come first on mobile */}
            <Col xs={24} lg={12} className="mobile-order-1">
              <h3
                className="details-heading"
                dangerouslySetInnerHTML={{
                  __html: t("about-us-details-page.introduction.title"),
                }}
              ></h3>
              <p
                className="details-para"
                dangerouslySetInnerHTML={{
                  __html: t("about-us-details-page.introduction.description"),
                }}
              ></p>
              <p
                className="details-para"
                dangerouslySetInnerHTML={{
                  __html: t("about-us-details-page.introduction.description2"),
                }}
              ></p>
            </Col>
          </Row>
        </div>

        {/* SECTION 2: Already has correct order (Text first, Image second) */}
        <div className="content-section">
          <Row className="mobile-direction-chng-2" gutter={[16, 16]}>
            <Col xs={24} lg={12}>
              <h3
                className="details-heading"
                dangerouslySetInnerHTML={{
                  __html: t("about-us-details-page.fanzaty-academy.title"),
                }}
              ></h3>
              <p
                className="details-para"
                dangerouslySetInnerHTML={{
                  __html: t(
                    "about-us-details-page.fanzaty-academy.description"
                  ),
                }}
              ></p>
            </Col>
            <Col xs={24} lg={12}>
              <div className="about-us-details-bg">
                <img
                  src={aboutUsPage}
                  alt="loading-tournament"
                  loading="lazy"
                />
              </div>
            </Col>
          </Row>
        </div>

        <div>
          {/* <p className="about-us-below-para">
            {t("about-us-details-page.below_heading")}
          </p> */}
        </div>
      </div>
    </section>
  );
};

export default AboutUsDetails;
